import axios from 'axios'

export const LOYALTY_LIFF_LOGIN_PATH = '/liff-login'

// Sub LIFF for the login route of a migrated shop. Missing or unreachable means
// "not migrated yet": the caller keeps the legacy liffMainIDLoyalty flow.
export async function resolveLoyaltyLiffLoginId (baseUrl, shopId) {
  if (!baseUrl || !shopId) {
    return null
  }
  try {
    const url = String(baseUrl).replace(/\/$/, '') +
      '/migrate/loyalty/liff-login/resolve?sourceShopId=' + encodeURIComponent(shopId)
    const result = await axios.get(url)
    const body = result.data || {}
    const liffId = body.ok && body.data ? body.data.liffId : ''
    return liffId ? String(liffId) : null
  } catch (err) {
    return null
  }
}

// Query of the page we came from, with LIFF/redirect bookkeeping removed, so the
// destination gets the same shopId/branchId/type it was opened with.
export function liffLoginForwardQuery (query) {
  const forward = {}
  Object.keys(query || {}).forEach(key => {
    if (key === 'liff.state' || key === 'liffRedirectUri' || key === 'redirect' || key === 'code' || key === 'state' || key === 'sourceShopId') {
      return
    }
    forward[key] = query[key]
  })
  return forward
}

export function liffLoginShopId (query) {
  const direct = query && (query.shopId || query.sourceShopId)
  if (direct) {
    return String(direct)
  }
  const state = query && typeof query['liff.state'] === 'string' ? query['liff.state'] : ''
  const params = new URLSearchParams(state.split('?')[1] || '')
  return params.get('shopId') || params.get('sourceShopId') || null
}

export function liffLoginRedirectPath (query) {
  const redirect = query && typeof query.redirect === 'string' ? query.redirect : ''
  if (!redirect || redirect.charAt(0) !== '/' || redirect.indexOf('//') === 0) {
    return '/'
  }
  return redirect
}



// WEBPACK FOOTER //
// ./src/utils/liffLogin.js